import { render } from "./empty-state-home.vue?vue&type=template&id=2ef81288"
import script from "./empty-state-home.vue?vue&type=script&lang=js"
export * from "./empty-state-home.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__